import o from "react";
import { useGlobalNavigation as e } from "../../hooks/useGlobalNavigation";
import { BrandFooter as G } from "./BrandFooter";
import { CorporateFooter as g } from "./CorporateFooter";
import { Newsletter as u } from "./Newsletter";
import { SitemapFooter as n } from "./SitemapFooter";

var C = function C(_ref) {
  var i = _ref.dataApi,
      m = _ref.wordmark,
      t = _ref.wordmarkUrl,
      r = _ref.newsletter,
      _ref$showSitemap = _ref.showSitemap,
      l = _ref$showSitemap === void 0 ? !0 : _ref$showSitemap,
      _ref$showCCPA = _ref.showCCPA,
      s = _ref$showCCPA === void 0 ? !0 : _ref$showCCPA,
      p = _ref.theme,
      _ref$testid = _ref.testid,
      d = _ref$testid === void 0 ? "hg-global-footer" : _ref$testid,
      _ref$as = _ref.as,
      b = _ref$as === void 0 ? "div" : _ref$as,
      f = _ref.style;
  var a = e(i);
  return o.createElement(b, {
    "data-theme": p,
    className: "hg-global-footer",
    "aria-label": "Global Footer Navigation",
    "data-testid": d,
    style: f
  }, o.createElement("div", {
    className: "hg-global-footer__content"
  }, o.createElement("div", {
    className: "hg-global-footer__brand-newsletter-container"
  }, o.createElement(G, {
    wordmark: m,
    wordmarkUrl: t
  }), o.createElement(u, {
    isSubmitted: r == null ? void 0 : r.isSubmitted,
    isProd: r == null ? void 0 : r.isProd
  })), l && o.createElement(n, {
    sitemapGroups: a == null ? void 0 : a.sitemapGroups
  }), o.createElement(g, {
    showCCPA: s,
    subdomain: "www",
    legalLinks: a == null ? void 0 : a.legalLinks
  })));
};

export { C as GlobalFooter };